export const SET_PAYFAC_INVOICES = 'SET_PAYFAC_INVOICES';
export const GET_PAYFAC_INVOICES = 'GET_PAYFAC_INVOICES';
export const UPDATE_INVOICE_AMOUNT = 'UPDATE_INVOICE_AMOUNT';

export const setPayfacInvoices = (invoices) => {
  return {
    type: SET_PAYFAC_INVOICES,
    payload: invoices
  };
};

export const getPayfacInvoices = () => {
  return {
    type: GET_PAYFAC_INVOICES,
    payload: invoices
  };
};

export const updateInvoiceAmount = (invoiceUuid, amountToPay) => {
  return {
    type: UPDATE_INVOICE_AMOUNT,
    payload: {
      invoiceUuid,
      amountToPay
    }
  };
};



// WEBPACK FOOTER //
// ./src/redux/actions/payfacActions.js